<template>
    <div>
        <div class="row">
            <div id="gdpr-thank-you-main-text" class="col-md-12">
                <h2>{{$store.state.form.user.title}} {{ $store.state.ime }} {{ $store.state.priimek }}, <span class="gdpr-color-text">hvala na povratnoj informaciji!</span></h2>
                <p v-html="$store.state.texts.thankYou.subtitle"></p>
            </div>
        </div>
        <div class="row social-text">
            <div class="col-md-12">
                <h3 v-html="$store.state.texts.thankYou.socialTitle"></h3>
                <p v-html="$store.state.texts.social.subtitle"></p>
            </div>
        </div>
        <div class="row">
            <div class="col-md-3 col-sm-6">
                <a href="https://www.renault.hr/" target="_blank"><div class="social-container">
                    <i class="fas fa-home fa-4x fa-inverse"></i>
                    <p v-html="$store.state.texts.social.icon1"></p>
                </div></a>
            </div>
            <div class="col-md-3 col-sm-6">
                <a href="https://www.facebook.com/RenaultHrvatska" target="_blank"><div class="social-container">
                    <i class="fab fa-facebook-f fa-4x fa-inverse"></i>
                    <p>Facebook</p>
                </div></a>
            </div>
            <div class="col-md-3 col-sm-6">
                <a href="https://www.instagram.com/renault_hr/" target="_blank"><div class="social-container">
                    <i class="fab fa-instagram fa-4x fa-inverse"></i>
                    <p>Instagram</p>
                </div></a>
            </div>
            <div class="col-md-3 col-sm-6">
                <a href="https://www.youtube.com/channel/UCx7jWVytrg6wzEySaw5bskA" target="_blank"><div class="social-container">
                    <i class="fab fa-youtube fa-4x fa-inverse"></i>
                    <p>Youtube</p>
                </div></a>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    beforeCreate() {
        if(this.$store.state.ime === ''  && this.$store.state.priimek === '') {
            this.$router.push({name: 'Form'})
        }
    },
    methods: {
        urediPodatke() {
            this.$emit('odjava', false);
        }
    }
}
</script>

<style lang="scss" scoped>
    /*SOCIAL*/
    .social-text {
        margin-top: 50px;
    }
    .social-container {
        text-align: center;
        background-color: #FFCE00;
        i {
            margin-top: 30px;
        }
        p {
            padding: 20px;
            color: white;
            position: relative;
        }
        p:after {
            content: ">";
            position: absolute;
            right: 15%;
            top: 36%;
        }
    }

    /* RESPONSIVE STYLING */
    @media only screen and (max-width : 992px) {
        .social-container {
            p:after {
                right: 30%;
            }
        }
    }
    @media only screen and (max-width: 768px) {
        .social-container {
            p:after {
                right: 35%;
            }
        }
    }
    @media only screen and (max-width : 480px) {
        .social-container {
            p:after {
                right: 30%;
            }
        }
    }
    @media only screen and (max-width : 320px) {
        .social-container {
            p:after {
                right: 25%;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/ThankYou.vue